<nz-drawer
  [nzWidth]="'80%'"
  [nzClosable]="true"
  [nzVisible]="visible"
  nzPlacement="right"
  nzTitle="Vehicle Dashboard"
  (nzOnClose)="visible = false"
  class="dashbSlider"
>
  <ng-container *nzDrawerContent>
    @if (selectedVehicle) {
    <app-vehicle-slider [vechile]="selectedVehicle"></app-vehicle-slider>
    }
  </ng-container>
</nz-drawer>
<div class="dashboard">
  <div class="row">
    <div class="col-lg-6 col-md-12 col-sm-12">
      <div id="livemap" class="shadowcard svmdbrdgrph"></div>
    </div>
    <div class="col-lg-6 col-md-12 col-sm-12">
      <nz-card class="shadowcard" style="width: 100%; height: auto">
        <div class="row bg-wp">
          <h1
            style="
              color: #9e1644;
              padding-left: 10px;
              padding-top: 10px;
              letter-spacing: 0px;
            "
          >
            Sachivalayam Vehicles Data
          </h1>
          <div class="ds-card grid tbl">
            <app-data-grid
              [allowedPageSizes]="[10, 20, 30, 50]"
              id="gridContainer"
              style="width: 100%"
              [dataSource]="vehcleTble"
              [legacyColumns]="columnDefs"
              [searchPanel]="true"
              [filterRow]="true"
              [filterPanel]="false"
              [groupPanel]="true"
              [columnChooser]="true"
              [allowExport]="true"
              exportFileName="vendor Vehicles Data"
              [pageSize]="10"
              [rowAlternationEnabled]="true"
              [showBorders]="true"
              [wordWrapEnabled]="true"
            >
              <app-grid-column
                [showInColumnChooser]="false"
                [visible]="true"
                type="buttons"
                [width]="100"
                caption="View"
                cellTemplate="editTemplate"
              ></app-grid-column>
              <ng-template appGridCell="editTemplate" let-data="cell"
                ><div>
                  <div class="tblEdtBtn" (click)="gotovehcleDashboard(data)">
                    <i nz-icon nzType="car" nzTheme="outline"></i>
                  </div></div
              ></ng-template>
            </app-data-grid>
          </div>
          <div>
            Click on <i nz-icon nzType="car" nzTheme="outline"></i> to View
            details of Vehicle
          </div>
        </div>
      </nz-card>
    </div>
  </div>
</div>
